import http from './http'

export function getVendorCard(vendorCode) {
  return http.get(`/api/card/vendors/${vendorCode}`)
}
